import { CuttingState } from "./CuttingState.d";
import { ShipmentState } from "./ShipmentState.d";
import { ShipmentType } from "./ShipmentType.d";
import { UserType } from "./UserType.d";
import { CordwoodMeasurementType } from "./CordwoodMeasurementType.d";


import {ID, ListRequest} from "../../../types/global.d";
import {displayTime, displayDate, displayDateTime} from "../../../utils/formatDate";
import {OrderBy} from "../../../types/global.d";

// Interface for entity TimberTypes


export interface TimberType {
    id: ID;

    
    name: string;

    
    description?: string;

    
    reportNameShort?: string;

    
    reportNameLong?: string;

    
    scopeGroupId: ID;

    }




export interface CreateTimberType {
    
    name: string;

    
    description?: string;

    
    reportNameShort?: string;

    
    reportNameLong?: string;

    
    }


export interface UpdateTimberType {
    
    name: string;

    
    description?: string;

    
    reportNameShort?: string;

    
    reportNameLong?: string;

    
    }

export interface PresentationTimberTypeRequest {
    list: ListRequest,
    filter: {
        name: string,
        nameOr: boolean,
        orderBys: OrderBy[],
        caseSensitive: boolean,
    },
}

export class PrimaryTimberType {
    id: string;


    constructor(
        id: ID,
        ) {
        this.id = id?.toString();
        }

    static fromEntity(entity: TimberType): PrimaryTimberType | undefined {
        return entity ? new PrimaryTimberType(
            entity.id,
        ) : undefined;
    }

    static fromId(id: ID
): PrimaryTimberType {
        return new PrimaryTimberType(
                id,
                );
    }
    
    static fromPath(path?: string): PrimaryTimberType {
        let vals = path?.split('/');
        return new PrimaryTimberType(
                   vals[0],
                );
    }

    static fromQuery(value?: string): number | undefined {
        return value ? value : undefined
    }

    toPath(): string {
        let ids = [
            this.id,
            ];
        return ids.join('/');
    }

    static toQueryParams(ids: PrimaryTimberType[]): string {
        return '?ids=' + ids.map(id => id.id).join('&ids=');
    }
}

export function toString(entity?: TimberType): string {
    let fields = entity ? [
    entity.name,
            ] : [];
    return fields.filter(item => item).join(' | ');
}

export class UpdateEntityTimberType {
    id: PrimaryTimberType;
    data: UpdateTimberType;


    constructor(id: PrimaryTimberType, data: UpdateTimberType) {
        this.id = id;
        this.data = data;
    }
}
